import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';
import { ArtistPortalConnectFailure } from 'fym-shared/src/smartlinks/artistPortals';

/**
 * What the artist reads when a sign-in that returns through music24-api fails
 * (`ArtistPortalAuthKind.oauthCallback`, YouTube today). One message per
 * `reason` code. The native apps read the same ids.
 */
export const portalConnectFailureMessages: Record<ArtistPortalConnectFailure, MessageDescriptor> = defineMessages({
  [ArtistPortalConnectFailure.denied]: {
    id: 'app.sml.catalog.connect.callback.error.denied',
    defaultMessage:
      'You cancelled the sign-in, or you did not allow every permission. Try again and allow all of them.',
  },
  [ArtistPortalConnectFailure.invalidState]: {
    id: 'app.sml.catalog.connect.callback.error.invalidState',
    defaultMessage: 'The sign-in took too long. Try again.',
  },
  [ArtistPortalConnectFailure.exchangeFailed]: {
    id: 'app.sml.catalog.connect.callback.error.exchangeFailed',
    defaultMessage: '{service} did not accept the sign-in. Try again.',
  },
  [ArtistPortalConnectFailure.noArtists]: {
    id: 'app.sml.catalog.connect.callback.error.noArtists',
    defaultMessage: 'This sign-in holds no channel. Sign in with the Google account that owns your channel.',
  },
  [ArtistPortalConnectFailure.notConfigured]: {
    id: 'app.sml.catalog.connect.callback.error.notConfigured',
    defaultMessage: '{service} cannot be connected right now. Try again later.',
  },
  [ArtistPortalConnectFailure.loginInUse]: {
    id: 'app.sml.catalog.connect.callback.error.loginInUse',
    defaultMessage:
      'This {service} account is connected to another artist in MUSIC24. Disconnect it there, or sign in with another {service} account.',
  },
  [ArtistPortalConnectFailure.unknown]: {
    id: 'app.sml.catalog.connect.callback.error.unknown',
    defaultMessage: 'The {service} sign-in did not finish. Try again.',
  },
});

/**
 * A sign-in that worked but holds no artist (Spotify, Deezer). Not the
 * callback's `noArtists`, which speaks of a Google channel. The native apps
 * read the same id.
 */
export const noArtistFoundMessage: MessageDescriptor = defineMessage({
  id: 'app.sml.catalog.connect.no_artist',
  defaultMessage:
    '{service} shows no artist on this sign-in. Sign in with the account that manages your artist profile.',
});
